var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { ReactViewController, RootViewController } from '@veeam/core';
import { DialogWizardLayout } from "../../../DialogWizard";
import { KeyCode } from "../../../helpers";
import { WizardTabsViewController } from './WizardTabsViewController';
import { WizardActionsViewController } from './WizardActionsViewController';
import { DIALOG_SIZE } from "../../../Dialog";
var WizardViewController = /** @class */ (function (_super) {
    __extends(WizardViewController, _super);
    function WizardViewController(config) {
        var _this = _super.call(this, { loading: false }) || this;
        _this.config = config;
        _this.tabsViewController = new WizardTabsViewController([]);
        _this.headerViewController = new RootViewController();
        _this.bodyViewController = new RootViewController();
        _this.actionsViewController = new WizardActionsViewController({
            prev: false,
            next: false,
            skip: false,
            done: false,
            cancel: true
        });
        _this.tabsViewController.width = _this.config.tabWidth;
        _this.tabsElement = _this.tabsViewController.render();
        _this.bodyElement = _this.bodyViewController.render();
        _this.actionsElement = _this.actionsViewController.render();
        return _this;
    }
    Object.defineProperty(WizardViewController.prototype, "listener", {
        get: function () {
            return this._listener;
        },
        set: function (listener) {
            this._listener = listener;
            this.tabsViewController.listener = listener;
            this.actionsViewController.listener = listener;
        },
        enumerable: true,
        configurable: true
    });
    WizardViewController.prototype.presentPending = function (state) {
        this.setState(state);
        this.actionsViewController.presentPending(state);
    };
    WizardViewController.prototype.presentNavigation = function (navigationState) {
        this.tabsViewController.present(navigationState.navigation);
        this.actionsViewController.present(navigationState.actions);
    };
    WizardViewController.prototype.registerTabViewController = function (tabId, viewController) {
        this.tabsViewController.registerTab(tabId, viewController);
    };
    WizardViewController.prototype.replaceBody = function (viewController) {
        this.bodyViewController.replace(viewController);
        this.actionsViewController.texts = viewController.texts;
    };
    WizardViewController.prototype.replaceHeader = function (viewController) {
        this.headerViewController.replace(viewController);
    };
    WizardViewController.prototype.createElement = function (state) {
        var _this = this;
        var _a;
        return (React.createElement(DialogWizardLayout, { loading: state.loading, pending: state.pending, tabs: this.tabsElement, dialogHeader: this.config.title || '', size: this.config.size || { height: DIALOG_SIZE.l, width: DIALOG_SIZE.l }, body: this.bodyElement, onRequestClose: (_a = this.listener) === null || _a === void 0 ? void 0 : _a.didSelectCancel.bind(this.listener), footer: this.actionsElement, onKeyPress: function (e) {
                var _a;
                if (e.keyCode === KeyCode.Enter) {
                    (_a = _this.listener) === null || _a === void 0 ? void 0 : _a.didEnterKeydown();
                }
            } }));
    };
    return WizardViewController;
}(ReactViewController));
export { WizardViewController };
//# sourceMappingURL=WizardViewController.js.map